import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const WyomingMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='wyoming'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='WY_ZS'
				points='901.1 806.48 376.97 814.13 171.06 808.14 174.5 667.74 178.35 519.12 888.27 523.98 901.1 806.48'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'WY_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('WY_ZS')}
			/>
			<polygon
				id='WY_ZN'
				points='888.27 523.98 875.64 245.76 594.62 255.59 352.72 256.26 185.3 250.81 178.35 519.12 888.27 523.98'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'WY_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('WY_ZN')}
			/>
			<rect
				x='492.08'
				y='678.48'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M491.47,718l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M525.95,714.83c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect x='422.27' y='339.5' width='72.08' height='43.33' fill='none' className='shape' />
			<path
				d='M421.65,379.02l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M455.51,382.1l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='815.44 774.58 815.55 778.9 820.1 778.9 815.62 781.58 815.73 785.9 812.85 783.23 808.37 785.9 811.07 781.58 808.2 778.9 812.74 778.9 815.44 774.58'
				className='shape'
			/>
			<rect x='695.4' y='780.84' width='212.23' height='20' fill='none' className='shape' />
			<path
				d='M707.33,797.36c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M711.83,797.88l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M735.44,797.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM733.24,787.55c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M742.97,786.27l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<path
				d='M761.62,797.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM759.42,787.55c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M766.55,797.88l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M781.79,797.88l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M805.4,797.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM803.2,787.55c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='733.04 750.03 733.15 754.35 737.7 754.35 733.22 757.02 733.32 761.35 730.45 758.67 725.97 761.35 728.67 757.02 725.79 754.35 730.34 754.35 733.04 750.03'
				className='shape'
			/>
			<rect x='629.62' y='727.17' width='101.55' height='20' fill='none' className='shape' />
			<path
				d='M633.44,728.03h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M650.95,744.21c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM652.24,734.09c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M658.26,744.21l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M675.65,744.21c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM676.94,734.09c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M682.95,744.21l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M704.77,744.21l2.22-11.61h1.99l-2.22,11.61h-1.99ZM707.35,729.36c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M721.06,743.54c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM718.86,733.89c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='319.25 302.33 319.36 306.65 323.9 306.65 319.42 309.32 319.53 313.65 316.65 310.97 312.17 313.65 314.88 309.32 312 306.65 316.55 306.65 319.25 302.33'
				className='shape'
			/>
			<rect x='323.85' y='284.29' width='61.98' height='20' fill='none' className='shape' />
			<path
				d='M335.78,300.8c-.91.41-2.38.78-4.2.78-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M351.25,294.28c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM342.32,296.75c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M367.48,284.29l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM364.14,291.54c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M372.71,289.72l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.18,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='656.54 550.91 656.64 555.23 661.19 555.23 656.71 557.9 656.82 562.23 653.94 559.55 649.46 562.23 652.16 557.9 649.29 555.23 653.83 555.23 656.54 550.91'
				className='shape'
			/>
			<rect x='661.14' y='557.16' width='78.63' height='20' fill='none' className='shape' />
			<path
				d='M673.07,573.68c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.04,1.23-5.95,3.45-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M685.07,574.2c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM686.36,564.08c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M692.47,572.19c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M702.7,578.96l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM705.97,572.26c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M727.21,573.54c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM725.01,563.88c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M732.14,574.2l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<polygon
				points='332.27 710.91 332.38 715.24 336.93 715.24 332.45 717.91 332.55 722.23 329.68 719.56 325.2 722.23 327.9 717.91 325.02 715.24 329.57 715.24 332.27 710.91'
				className='shape'
			/>
			<rect x='192.49' y='688.9' width='154.03' height='20' fill='none' className='shape' />
			<path
				d='M196.28,690c.99-.22,2.33-.35,3.53-.35,1.62,0,3,.38,3.86,1.17.75.65,1.19,1.58,1.19,2.68,0,2.35-1.8,4.1-3.84,4.67v.06c1.13.38,1.66,1.59,1.78,3.25.18,2.25.29,3.8.5,4.45h-2.06c-.09-.34-.26-2.04-.37-3.9-.13-2.23-.94-3.15-2.55-3.15h-1.77l-1.34,7.05h-1.97l3.03-15.94ZM196.86,697.34h1.78c2.52,0,4.15-1.65,4.15-3.59,0-1.73-1.3-2.51-3.13-2.51-.79,0-1.3.07-1.68.17l-1.13,5.92Z'
				className='shape'
			/>
			<path
				d='M219.24,698.89c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM210.32,701.36c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M231.11,705.48c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M235.71,705.94l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.77,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M256.18,703.44c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M268.47,710.69l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM271.74,703.99c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M284.54,705.94l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M294.57,705.94l2.22-11.61h1.99l-2.22,11.61h-1.99ZM297.16,691.09c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M302.49,705.94l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M317.83,708.58c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1.01-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM326.76,696.06c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M332.83,703.92c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<polygon
				points='577.14 270.73 577.24 275.05 581.79 275.05 577.31 277.72 577.42 282.05 574.54 279.37 570.06 282.05 572.76 277.72 569.89 275.05 574.43 275.05 577.14 270.73'
				className='shape'
			/>
			<rect x='581.74' y='276.98' width='106.12' height='20' fill='none' className='shape' />
			<path
				d='M582.74,291.52c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M596.05,294.02l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.81h-1.99Z'
				className='shape'
			/>
			<path
				d='M619.66,293.36c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM617.46,283.7c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M624.59,294.02l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M634.62,294.02l2.22-11.61h1.99l-2.22,11.61h-1.99ZM637.2,279.17c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M654.88,276.98l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM651.54,284.23c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M665.26,294.02c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM666.55,283.9c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M672.56,294.02l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='715.25 333.49 715.36 337.81 719.91 337.81 715.43 340.49 715.54 344.81 712.66 342.14 708.18 344.81 710.88 340.49 708.01 337.81 712.55 337.81 715.25 333.49'
				className='shape'
			/>
			<rect x='719.86' y='339.75' width='93.71' height='20' fill='none' className='shape' />
			<path
				d='M732.51,356.09c-.94.37-2.66.86-4.56.86-2.28,0-4.06-.65-5.29-2.02-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.49,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.43,3.73-2.43,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.19,2.46-.46l.92-4.83h-3.27l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M737.94,356.79l2.22-11.61h1.99l-2.22,11.61h-1.99ZM740.52,341.94c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M745.86,356.79l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M753.78,356.79l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M770.07,356.12c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM767.87,346.46c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M780.19,342.06l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M790.12,342.06l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M803.14,356.12c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM800.94,346.46c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='204.26 466.01 204.36 470.33 208.91 470.33 204.43 473.01 204.54 477.33 201.66 474.66 197.18 477.33 199.88 473.01 197.01 470.33 201.55 470.33 204.26 466.01'
				className='shape'
			/>
			<rect x='208.86' y='472.27' width='95.08' height='20' fill='none' className='shape' />
			<path
				d='M208.55,487.45c.53.22,1.18.35,2.04.35,1.7,0,2.78-.9,3.31-3.76l2.07-10.91h1.99l-2.11,11.13c-.71,3.79-2.29,5.31-5.32,5.31-.98,0-1.99-.21-2.4-.42l.43-1.7Z'
				className='shape'
			/>
			<path
				d='M228.45,489.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM229.74,479.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M243.69,488.85c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M248.28,489.31l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.07,4.77,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.97Z'
				className='shape'
			/>
			<path
				d='M261.74,487.29c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M284.16,482.26c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM275.23,484.73c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M287.97,489.31l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
		</svg>
	);
};

WyomingMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default WyomingMap;
